export const Keys = {
  products: 'stripe-products',
  productsForUpdate: 'stripe-products-for-update',
  previewProrata: 'stripe-preview-prorata',
  subscriptions: 'stripe-subscriptions',
  startSubscriptionsNow: 'stripe-start-subscriptions-now',
  customerPortal: 'stripe-customer-portal',
  checkoutSession: 'stripe-checkout-session',
  invoices: 'stripe-invoices',
  addonCreditsPaymentIntent: 'stripe-addon-credits-payment-intent',
  paymentMethod: 'stripe-customer-payment-method',
} as const;
